
import { CostsPerEmployeeConfiguration } from "./cost-per-employee-configuration";

export class CostsPerEmployeeGroup {

    id: number = 0;
    description!: string;
    costsPerEmployeeConfigurations: CostsPerEmployeeConfiguration [] = [];

}